import { render, staticRenderFns } from "./SettingsTokenTypes.vue?vue&type=template&id=4dab7f58&scoped=true&"
import script from "./SettingsTokenTypes.vue?vue&type=script&lang=ts&"
export * from "./SettingsTokenTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dab7f58",
  null
  
)

export default component.exports